import LogRocket from 'logrocket'
import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import * as Intercom from '@/analytics/intercom'
import { VUE_APP_LOGROCKET_PROJECT, VUE_APP_SENTRY_DSN, VUE_APP_VERSION, VUE_APP_INTERCOM_APP_ID, VUE_APP_PENDO_LICENSE_KEY } from '@/config'
import { appendPendoScriptTag } from './pendo'

import UserInfo from './UserInfo'

let useLogRocket = false
let useSentry = false
let useIntercom = false
let usePendo = false

// LogRocket

const logRocketProject = VUE_APP_LOGROCKET_PROJECT
if (logRocketProject) {
  useLogRocket = true
  LogRocket.init(logRocketProject, {
    network: {
      requestSanitizer: request => {
        const PROTECTED_ROUTE_TOKENS = ['auth', 'password']
        if (PROTECTED_ROUTE_TOKENS.some(token => request.url.toLowerCase().includes(token))) {
          request.body = undefined
        }

        return request
      }
    },
    console: {
      shouldAggregateConsoleErrors: true
    }
  })
}

// Sentry

if (VUE_APP_SENTRY_DSN) {
  useSentry = true
  const release = `ocean@${VUE_APP_VERSION}`
  console.log(release)
  Sentry.init({
    release,
    dsn: VUE_APP_SENTRY_DSN,
    integrations: [
      new Integrations.Vue({
        Vue,
        // Would be cool to have this set to true, but we have a lot
        // of really big payloads being passed through props and
        // sentry has a max upload size of 200kb, which caused the
        // error event to not even fire. So this is safer.
        attachProps: false,
        logErrors: false // this option needs to be turned on in Vue too to work
      })
    ]
  })
}

// Intercom

if (VUE_APP_INTERCOM_APP_ID) {
  useIntercom = true
  Intercom.init(VUE_APP_INTERCOM_APP_ID)
}

// Pendo

if (VUE_APP_PENDO_LICENSE_KEY) {
  usePendo = true
  appendPendoScriptTag()
}

// Configure integrations between monitoring services

if (useLogRocket && useSentry) {
  LogRocket.getSessionURL(sessionURL => {
    Sentry.configureScope(scope => {
      scope.setExtra('sessionURL', sessionURL)
    })
  })
}

export function identifyForMonitoring (userInfo: UserInfo) {
  if (useLogRocket) {
    LogRocket.identify(userInfo.userId, {
      name: `${userInfo.firstName} ${userInfo.lastName}`,
      email: userInfo.email
    })
  }

  if (useSentry) {
    Sentry.configureScope(scope => {
      scope.setUser({
        ...userInfo,
        id: userInfo.userId
      })
    })
  }

  if (useIntercom) {
    Intercom.trackUser(VUE_APP_INTERCOM_APP_ID!, userInfo)
  }

  if (usePendo) {
    const { pendo } = window as unknown as Window & { pendo: any }
    pendo && pendo.initialize({
      visitor: {
        id: userInfo.userId,
        email: userInfo.email
      },
      account: {
        id: userInfo.accountId
      }
    })
  }
}
